import { useNavigate, useParams } from "react-router-dom";

type NavigateOptions = {
  replace?: boolean;
  state?: any;
};

export const useLangNavigate = () => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();

  return (path: string, options?: NavigateOptions) => {
    if (!lang) return;

    // 앞에 / 있으면 제거
    const normalizedPath = path.startsWith("/") ? path.slice(1) : path;

    navigate(`/${lang}/${normalizedPath}`, options);
  };
};
